<template>
    <div>
        <h1 class="mb-4"><v-icon color="primary">mdi-account-plus</v-icon> Registrar Usuario</h1>
        <v-progress-linear :active="cargando" :indeterminate="cargando" absolute top color="primary" />
        <form-usuario :usuario="usuario" @registrado="onRegistrado" />
        <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top>
            {{ mensaje.texto }}
        </v-snackbar>
    </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import FormUsuario from './FormUsuario.vue'

export default {
    name: 'NuevoUsuario',
    components: { FormUsuario },

    data: () => ({
        cargando: false,
        usuario: {
            usuario: '',
            nombre: '',
            telefono: '',
            rol: 'recepcionista',
        },
        mostrarMensaje: false,
        mensaje: { texto: '', color: '' },
    }),

    methods: {
        onRegistrado(usuario) {
            this.cargando = true
            HttpService.registrar({ metodo: 'registrar', usuario }, 'usuarios.php')
            .then(resultado => {
                if (resultado) {
                    this.mostrarMensaje = true
                    this.mensaje = { texto: 'Usuario registrado exitosamente', color: 'success' }
                    this.cargando = false
                    this.usuario = { usuario: '', nombre: '', telefono: '', rol: 'recepcionista' }
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/NuevoUsuario.vue